(() => {
  if (customElements.get('ksm-search')) return;
  class KsmSearch extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('.kssearch__suggestions');
      this.status = this.querySelector('[role="status"]');
      this.clear = this.querySelector('[type="reset"]');
      this.version = 0;
      this.input.addEventListener('input', () => this.update());
      this.querySelector('form').addEventListener('reset', event => { event.preventDefault(); this.input.value = ''; this.update(); this.input.focus(); });
      this.addEventListener('keydown', event => {
        const links = Array.from(this.results.querySelectorAll('a'));
        if (this.results.hidden || !links.length) return;
        const index = links.indexOf(document.activeElement);
        if (event.key === 'ArrowDown') { event.preventDefault(); links[Math.min(index + 1, links.length - 1)].focus(); }
        if (event.key === 'ArrowUp') { event.preventDefault(); if (index <= 0) this.input.focus(); else links[index - 1].focus(); }
      });
    }
    update() {
      clearTimeout(this.timer);
      this.controller?.abort();
      const version = ++this.version;
      const query = this.input.value.trim();
      this.clear.hidden = !query;
      this.results.hidden = true;
      this.results.replaceChildren();
      this.status.textContent = '';
      this.removeAttribute('aria-busy');
      const discover = this.closest('dialog')?.querySelector('[data-ks-search-discover]');
      if (discover) discover.hidden = Boolean(query);
      if (!query) return;
      this.timer = setTimeout(() => this.search(query, version), 220);
    }
    async search(query, version) {
      this.controller = new AbortController();
      this.status.textContent = this.dataset.loading;
      this.setAttribute('aria-busy', 'true');
      const url = new URL(this.dataset.endpoint, location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product,article');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[limit_scope]', 'all');
      url.searchParams.set('section_id', 'ksm-search-suggestions');
      try {
        const response = await fetch(url, {signal: this.controller.signal});
        if (!response.ok) throw new Error('Search request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('[data-ks-search-response]');
        if (!content) throw new Error('Search response missing');
        if (version !== this.version) return;
        this.results.replaceChildren(content);
        this.results.hidden = false;
        this.status.textContent = this.dataset.ready.replace('[count]', content.dataset.count);
      } catch (error) {
        if (error.name !== 'AbortError' && version === this.version) this.status.textContent = this.dataset.error;
      } finally { if (version === this.version) this.removeAttribute('aria-busy'); }
    }
  }
  customElements.define('ksm-search', KsmSearch);
  const dialog = document.getElementById('KsmSearchDialog');
  if (!dialog) return;
  let opener;
  let previousOverflow;
  const close = () => dialog.close();
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-ks-search-open], [data-side-drawer="#Drawer-Search"]');
    if (!trigger) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (dialog.open) return;
    opener = trigger.matches('a,button') ? trigger : trigger.querySelector('a,button') || trigger;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    dialog.querySelector('input[type="search"]').focus();
  }, true);
  dialog.querySelector('[data-ks-search-close]').addEventListener('click', close);
  dialog.addEventListener('click', event => {
    if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(); }
    const chip = event.target.closest('[data-ks-search-term]');
    if (chip) { const search = dialog.querySelector('ksm-search'); search.input.value = chip.dataset.ksSearchTerm; search.update(); search.input.focus(); }
  });
  dialog.addEventListener('close', () => { document.body.style.overflow = previousOverflow || ''; opener?.focus(); });
})();
